export default "__VITE_ASSET__BlEb$hJS__"